import ReactDOM from 'react-dom/client';
import App from './App';
import { applyStyleToShadow } from './lib/apply-style-to-shadow';
import './types.js';
import { CustomMuiTheme } from './theme.js';

export const __APP_ROOT = document.getElementById('wppr-cropper-root');
export const __APP_SHADOW_ROOT = __APP_ROOT?.shadowRoot;
if (__APP_SHADOW_ROOT && __APP_ROOT) { 
  __APP_ROOT.style.position = 'relative';
  const shadowRootElement = document.createElement('div');
  __APP_SHADOW_ROOT.appendChild(shadowRootElement);
  applyStyleToShadow('#wppr-cropper-styles-css', __APP_SHADOW_ROOT);
  ReactDOM.createRoot(__APP_SHADOW_ROOT).render(
    <CustomMuiTheme shadowRoot={__APP_SHADOW_ROOT}>
      <App />
    </CustomMuiTheme>    
  );
}